
{
  "nav.startHere": "Commencer ici",
  "nav.about": "À propos",
  "nav.protocols": "Protocoles",
  "nav.tools": "Outils",
  "nav.compliance": "Conformité",
  "nav.personal": "Protocole personnel",
  "nav.organization": "Protocole organisationnel",
  "nav.mission": "Mission et vision",
  "nav.scope": "Portée et non-garantie",
  "nav.standards": "Cartographie des normes",
  "nav.changelog": "Journal des modifications",
  "nav.governance": "Gouvernance",
  "nav.disclaimer": "Avertissement légal",
  "nav.contact": "Nous contacter",
  
  "hero.title1": "Sécurisez votre",
  "hero.title2": "Monde numérique",
  "hero.subtitle": "Une plateforme mondiale de protocole de cybersécurité et de préparation pour les particuliers et les organisations. Basée sur des pratiques standard de l'industrie et des cadres de sécurité mondiaux.",
  "hero.cta.start": "Commencer l'évaluation de sécurité",
  "hero.cta.learn": "En savoir plus",
  "hero.trust.standards": "Aligné sur les normes",
  "hero.trust.standardsDesc": "Meilleures pratiques mondiales",
  "hero.trust.defensive": "Défensif uniquement",
  "hero.trust.defensiveDesc": "Conseils de sécurité éthiques",
  "hero.trust.global": "Plateforme mondiale",
  "hero.trust.globalDesc": "Protocoles internationaux",
  
  "home.tab.personal": "Protocole personnel",
  "home.tab.organization": "Protocole organisationnel",
  "home.personal.title": "Commencez par ces 10 étapes",
  "home.personal.desc": "Contrôles de sécurité essentiels que chaque individu doit mettre en œuvre immédiatement pour prévenir 90% des attaques courantes.",
  "home.org.title": "Base de sécurité organisationnelle",
  "home.org.desc": "Contrôles de gouvernance et techniques essentiels que chaque organisation devrait établir pour réduire les risques cybernétiques et améliorer la résilience.",
  "home.org.note": "Ces étapes représentent une base minimale que les organisations peuvent mettre en œuvre immédiatement, quelle que soit leur taille ou leur secteur.",
  "home.principle1.title": "Défense en profondeur",
  "home.principle1.titleOrg": "Sécurité en couches",
  "home.principle1.desc": "Appliquer plusieurs contrôles de sécurité indépendants afin que la défaillance d'un seul contrôle ne compromette pas la sécurité globale.",
  "home.principle1.descOrg": "Plusieurs contrôles indépendants de sorte que si l'un échoue, les autres restent efficaces.",
  "home.principle2.title": "Mentalité zéro confiance",
  "home.principle2.titleOrg": "Vérification continue",
  "home.principle2.desc": "Ne vous fiez pas à la confiance implicite. Vérifiez continuellement l'accès en fonction de l'identité, de l'appareil et du contexte.",
  "home.principle2.descOrg": "Vérifiez chaque demande d'accès et supposez une compromission potentielle à tout moment.",
  "home.standards.badge": "Approche basée sur les normes",
  "home.standards.title": "Construit sur des normes de sécurité mondiales",
  "home.standards.desc": "Nos protocoles sont rigoureusement alignés sur des cadres de cybersécurité et des meilleures pratiques reconnus internationalement.",
  "home.standards.risk.title": "Gestion des risques",
  "home.standards.risk.desc": "Approche globale basée sur les risques pour la gouvernance de la cybersécurité et la résilience opérationnelle.",
  "home.standards.risk.functions": "Gouverner, identifier, protéger, détecter, répondre, récupérer",
  "home.standards.controls.title": "Contrôles de sécurité",
  "home.standards.controls.desc": "Norme internationale pour les systèmes de gestion de la sécurité de l'information avec des contrôles complets.",
  "home.standards.controls.count": "114 contrôles de sécurité dans 14 domaines",
  "home.standards.practices.title": "Meilleures pratiques",
  "home.standards.practices.desc": "Contrôles de sécurité priorisés et exploitables pour se défendre contre les cyberattaques les plus courantes.",
  "home.standards.practices.count": "18 contrôles de sécurité critiques",
  "home.standards.cta": "Voir la cartographie complète des normes",
  
  "footer.brand.desc": "Une plateforme mondiale de protocole de cybersécurité et de préparation pour les particuliers et les organisations.",
  "footer.brand.note": "Conseils de sécurité défensifs alignés sur les normes.",
  "footer.protocols": "Protocoles",
  "footer.resources": "Ressources",
  "footer.about": "À propos",
  "footer.riskAssessment": "Évaluation des risques",
  "footer.toolsLibrary": "Bibliothèque d'outils",
  "footer.complianceGuides": "Guides de conformité",
  "footer.standardsMapping": "Cartographie des normes",
  "footer.missionVision": "Mission et vision",
  "footer.scopeDisclaimer": "Portée et avertissement",
  "footer.contact": "Contact",
  "footer.copyright": "CyberSecurityProtocol. Tous droits réservés.",
  "footer.educational": "Conseils de cybersécurité éducatifs et défensifs uniquement.",
  "footer.legal": "Légal",
  "footer.nonGuarantee": "Non-garantie",
  "footer.builtBy": "Construit par UXER — Partie de l'Association de technologie de l'information et open source (ATIOS)",
  
  "common.loading": "Chargement...",
  "common.error": "Erreur",
  "common.success": "Succès",
  "common.cancel": "Annuler",
  "common.save": "Enregistrer",
  "common.continue": "Continuer",
  "common.back": "Retour",
  "common.next": "Suivant",
  "common.finish": "Terminer",
  "common.viewMore": "Voir plus",
  "common.learnMore": "En savoir plus",
  "common.getStarted": "Commencer"
}
